export const RESET_PASSWORD = "RESET_PASSWORD";
export const LOGIN_WITH_BOOKING_REFERENCE = "LOGIN_WITH_BOOKING_REFERENCE";
export const SET_USER_BIID = "SET_USER_BIID";
export const SET_SESSION_BIID = "SET_SESSION_BIID";
export const LOGIN = "LOGIN";
export const SET_CAN_LOGIN_AT = "SET_CAN_LOGIN_AT";
export const RESEND_CONFIRMATION_EMAIL = "RESEND_CONFIRMATION_EMAIL";
